// extracted by mini-css-extract-plugin
export default {"picker":"ColourPicker_picker__e4GC4","swatch":"ColourPicker_swatch__ZJiOF","selected":"ColourPicker_selected__pminF"};